<mat-sidenav-container class="sidenav-container" [class.fullscreen]="hideLayout">
  <mat-sidenav *ngIf="!hideLayout" #sidenav [mode]="isMobile ? 'over' : 'side'" [opened]="!isMobile"
    (closedStart)="isMobile ? (collapsed = false) : null" [class.collapsed]="!isMobile && collapsed"
    class="custom-sidenav">
    <app-teacher-sidenavbar [collapsed]="collapsed" (toggle)="toggleSidenav()"
      (routeSelected)="closeSidenav()"></app-teacher-sidenavbar>
  </mat-sidenav>

  <mat-sidenav-content [class.content-collapsed]="collapsed && !hideLayout"
    [class.content-expanded]="!collapsed && !hideLayout" [class.fullscreen-content]="hideLayout">

    <app-top-navbar *ngIf="!hideLayout" (triggerSidenav)="toggleSidenav()"></app-top-navbar>

    <div class="page-content">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>